<template>
    <v-dialog v-model="dialog" persistent max-width="700px">
      <template v-slot:activator="{ on, attrs }">
        <v-icon
          color="primary"
          dark
          v-bind="attrs"
          v-on="on"
          small
          class="mx-1"
          >fas fa-pencil-alt
        </v-icon>
      </template>
      <v-card>
        <v-card-title>
          <span class="headline">Edit Project</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form
              ref="form"
              v-model="valid"
            >
            <v-row>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  v-model="project.title"
                  label="title"
                  :rules="[v => !!v || 'Item is required']"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  :return-value.sync="project.start_date"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="project.start_date"
                      label="Start Date"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="project.start_date" :rules="[v => !!v || 'Item is required']" no-title scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
                    <v-btn text color="primary" @click="$refs.menu.save(project.start_date)">OK</v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-menu
                  ref="menu1"
                  v-model="menu1"
                  :close-on-content-click="false"
                  :return-value.sync="project.deadline_date"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="project.deadline_date"
                      label="Deadline Date"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="project.deadline_date" :rules="[v => !!v || 'Item is required']" no-title scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="menu1 = false">Cancel</v-btn>
                    <v-btn text color="primary" @click="$refs.menu1.save(project.deadline_date)">OK</v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-select
                  v-model="project.category"
                  :items="['Website','Application','Branding','Other']"
                  :rules="[v => !!v || 'Item is required']"
                  label="Category"
                  required
                ></v-select>
              </v-col>
              <v-col cols="12" sm="6" md="8">
                <v-text-field
                  v-model="project.description"
                  label="description"
                  :rules="[v => !!v || 'Item is required']"
                  required
                ></v-text-field>
              </v-col>
              
              <v-col cols="12" sm="6" md="4">
                <v-select
                  v-model="project.client_id"
                  :items="allclients"
                  item-text="name"
                  item-value="id"
                  :rules="[v => !!v || 'Item is required']"
                  label="Client"
                  required
                ></v-select>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-select
                  v-model="project.leader"
                  :items="allusers"
                  item-text="name"
                  item-value="id"
                  :rules="[v => !!v || 'Item is required']"
                  label="leader"
                  required
                ></v-select>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-select
                  v-model="project.assign_to"
                  :items="allusers"
                  item-text="name"
                  item-value="id"
                  :rules="[v => !!v || 'Item is required']"
                  label="Assign To"
                  required
                ></v-select>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  v-model="project.quoted_amount"
                  label="Quote Amount"
                  type="number"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  v-model="project.paid_amount"
                  label="Paid Amount"
                  type="number"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-select
                  v-model="project.project_status"
                  :items="['Lead','Working Quotation','Quotation Sent','Project Approved','Closed']"
                  :rules="[v => !!v || 'Item is required']"
                  label="project_status"
                  required
                ></v-select>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-select
                  v-model="project.work_status"
                  :items="['Standby','Working','Awaiting Resources','Testing','Pending Approval','Done']"
                  :rules="[v => !!v || 'Item is required']"
                  label="Work Status"
                  required
                ></v-select>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-select
                  v-model="project.payment_status"
                  :items="['No Payment','Advance paid','Second advance paid','Fully paid']"
                  :rules="[v => !!v || 'Item is required']"
                  label="Payment Status"
                  required
                ></v-select>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-select
                  v-model="project.project_source"
                  :items="['Direct','Referal']"
                  :rules="[v => !!v || 'Item is required']"
                  label="Project Source"
                  required
                ></v-select>
              </v-col>
            </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialog = false">Close</v-btn>
          <v-btn color="success darken-1" text :disabled="!valid" @click="editproject1()">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
import { mapGetters,mapActions } from 'vuex';
  export default {
    props : {
        projectid: Number
    },
    data: () => ({
      menu: '',
      menu1: '',
      valid: true,
      data: {},
      dialog: false,
      project: '',
    }),
    computed: {
      ...mapGetters(["allclients","allsalesperson","allusers",'allprojects']),
    },
    created () {
      let project1 = this.allprojects.filter(product => product.id === this.projectid);
      this.project = project1[0];
    },
    methods:{
      ...mapActions(['editproject','fetchprojects']),
      editproject1() {
        if(this.$refs.form.validate())
        {
          this.editproject(this.project);
          this.dialog = false;
        }
      }
    }
  }
</script>